// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  SceneNodeType,
} from "./types";

export default {
  versionId: __t.u64(),
  fileId: __t.u64(),
  name: __t.string(),
  parentNodeId: __t.option(__t.u64()),
  nodePath: __t.string(),
  translateX: __t.f64(),
  translateY: __t.f64(),
  translateZ: __t.f64(),
  rotateX: __t.f64(),
  rotateY: __t.f64(),
  rotateZ: __t.f64(),
  rotateW: __t.f64(),
  scaleX: __t.f64(),
  scaleY: __t.f64(),
  scaleZ: __t.f64(),
  get nodeType() {
    return SceneNodeType;
  },
  meshTriangleCount: __t.option(__t.u32()),
};
